export type CurrencyCode = 'USD' | 'EUR';

export const CURRENCY_SYMBOLS: Record<CurrencyCode, string> = {
  USD: '$',
  EUR: '€',
};
